import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mocuts/challenge_back.webp";

function Challengemocuts() {
  return (
    <section
      className="challenge_mocuts text_mocuts"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Challenges & <span>Solutions</span>
            </h2>
            <p>
              The client had this vision to build an on-demand barber service
              booking app where both buyers and sellers can create their
              profiles and benefit from features like in-app messaging, live
              tracking, ratings and reviews, and one-click payment options. For
              this, we had to create two separate versions of MoCuts Pro. One is
              for the users to hire barbers and beauticians, and the other is
              for barbers and service providers to create their profiles,
              receive or cancel orders, perform transactions from the app to
              their wallets, maintain their profiles, etc.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengemocuts;
